export default {
  singleLabel: "Utilisateur",
  storeNamespace: 'user',
  authFeature: 'user',
  listRouteName: "UserList",
  newRouteName: "UserNew",
  editRouteName: "UserEdit",
  detailRouteName: "UserDetail",
  useNewModal: true,
  useEditModal: true,
  formComponentName: 'UserForm',
  csvExportFilenamePrefix: 'utilisateurs',
  hideActionPdfButton: true,
  titleField: 'firstname',
  sortBy: 'firstname',
  showExtendedFilters: true,
  fields: [
    {
      name: 'firstname',
      label: "Prénom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
    },
    {
      name: 'lastname',
      label: "Nom",
      type: 'text',
      inForm: true,
      required: true,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
    },
    {
      name: 'role',
      label: "Rôle",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'roles',
      label: "Rôle",
      type: 'select',
      inList: true,
      sortable: true,
      filterIn: false,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value && value[0] ? context.$store.getters['user/getRole'](value[0]) ? context.$store.getters['user/getRole'](value[0]).text : null : null
    },
    {
      name: 'employee_id',
      label: "Matricule / GID",
      type: 'chosen',
      inForm: true,
      required: true,
    },
    {
      name: 'matricule',
      label: "Matricule",
      type: 'text',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value, item) => item && item.employee && item.employee.number ? item.employee.number : null
    },
    {
      name: 'gaia_id',
      label: "GID",
      type: 'text',
      inForm: false,
      inList: true,
      sortable: true,
      filterIn: true,
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value, item) => item && item.employee && item.employee.gaia_id ? item.employee.gaia_id : null
    },
    {
      name: 'agencies',
      label: "Agences",
      type: 'chosen',
      multiple: true,
      inForm: true,
      inList: true,
      inDetail: true,
      inCsvExport: true,
      formatter: (context, value) => value ? value.map(item => item.internal_number+" - "+item.name).join(", ") : null,
      inFormCondition: (form) => !["ROLE_ADMIN", "ROLE_DIRECTION", "ROLE_PREPARATOR", "ROLE_MAINTAINER", "ROLE_VERSATILE_TECHNICIAN"].includes(form.role)
    },
    {
      // INC-001 : entrepôt de rattachement unique (vide = accès à tous les entrepôts)
      name: 'warehouse',
      label: "Entrepôt",
      type: 'select',
      inForm: true,
      inList: true,
      extendedFilter: true,
      inDetail: true,
      inCsvExport: false,
      formatter: (context, value) => value ? value.internal_code+" - "+value.name : "Tous les entrepôts",
    },
    {
      // Filtre "provenance MCS" : les comptes importés de MCS portent user.source = 'MCS'.
      // Filtre seul, pas une colonne.
      name: 'mcs',
      label: "Import MCS",
      type: 'select',
      extendedFilter: true,
    },
    {
      name: 'status',
      label: "Statut",
      type: 'select',
      inList: true,
      tabFilter: true,
      tabFilterDefaultValue: 'user-active',
      key: 'status_slug',
      inDetail: true,
      inCsvExport: true,
      inPdfExport: true,
      formatter: (context, value) => value ? value.name : null
    },
    {
      name: 'status_slug',
      label: "Statut",
      type: 'select',
      inForm: true,
      required: true,
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inForm: false,
      inList: false,
      inDetail: false,
      formatter: (context, value) => value ? context.$moment(value).format("dddd, DD MMMM YYYY à H:mm") : null
    },
    {
      name: 'created_at',
      label: "Création",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
    {
      name: 'updated_at',
      label: "Dernière modification",
      type: 'date',
      inCsvExport: true,
      formatter: (context, value) => value ? context.$moment(value).format("DD/MM/YYYY") : null
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/User/config.js